<template>
  <div class="form__field-container">
    <input
      class="form__input"
      :type="passwordFieldType"
      v-model="password"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      :minlength="minLength"
      :required="true"
      :id="id"
      :autofocus="autofocus"
      @input="$emit('input', $event.target.value)"
    />
    <button type="button" class="form__password-toggle password-toggle" @click="switchVisibility">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ShowPassword",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "********" },
    name: { type: String, default: "" },
    allowShorterOldPasswords: { type: Boolean, default: false },
    autofocus: Boolean,
    id: { type: String, default: null }
  },
  data: () => ({
    passwordFieldType: "password",
    password: ""
  }),
  computed: {
    buttonText() {
      return this.passwordFieldType === "password" ? this.$t("show") : this.$t("hide")
    },
    minLength() {
      return this.allowShorterOldPasswords ? 4 : 8
    }
  },
  methods: {
    switchVisibility(e) {
      e.preventDefault()

      if (this.passwordFieldType === "password") {
        this.passwordFieldType = "text"
      } else {
        this.passwordFieldType = "password"
      }
    }
  },
  i18n: {
    messages: {
      en: {
        hide: "Hide",
        show: "Show"
      },
      de: {
        hide: "Verstecken",
        show: "Anzeigen"
      },
      es: {
        hide: "Ocultar",
        show: "Mostrar"
      },
      pt: {
        hide: "Ocultar",
        show: "Mostrar"
      }
    }
  }
}
</script>
